import React from 'react';
import { 
  HelpCircle, 
  Calendar, 
  Clock, 
  Briefcase, 
  FileText, 
  CheckSquare, 
  CalendarCheck, 
  Zap
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными советами
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Calendar,
      title: 'Дата начала',
      description: 'Для точного расчета убедитесь, что начальная и конечная даты введены в формате ДД.ММ.ГГГГ.'
    },
    {
      icon: Clock,
      title: 'Рабочие дни',
      description: 'Включите опцию "Рабочие дни" для расчета только будних дней (пн-пт) без выходных.'
    },
    {
      icon: Briefcase,
      title: 'Учет праздников',
      description: 'Для планирования рабочего времени включите опцию "Исключить праздники" с использованием российских праздников.'
    },
    {
      icon: FileText,
      title: 'Сохранение',
      description: 'Сохраняйте часто используемые расчеты для быстрого доступа к ним в будущем.'
    },
    {
      icon: CheckSquare,
      title: 'Подсчет дней недели',
      description: 'Вы можете подсчитать количество определенных дней недели (например, понедельников) в выбранном периоде.'
    },
    {
      icon: CalendarCheck,
      title: 'Нерабочие дни',
      description: 'Добавьте свои собственные праздники или нерабочие дни, если они отличаются от стандартных российских праздников.'
    },
    {
      icon: Zap,
      title: 'Быстрый расчет',
      description: 'Используйте кнопки быстрого расчета для стандартных периодов, например "30 дней" или "До конца года".'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-cyan-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-cyan-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-cyan-50 dark:bg-cyan-900/20 border border-cyan-100 dark:border-cyan-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-cyan-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-cyan-700 dark:text-cyan-300 mb-2">
              Узнайте больше
            </h4>
            <p className="text-xs text-cyan-600 dark:text-cyan-400 mb-3">
              Для корректного расчета рабочих дней учитывайте производственный календарь и региональные особенности России.
            </p>
            <button className="w-full py-1.5 text-xs bg-cyan-500 text-white rounded hover:bg-cyan-600 transition-colors">
              Скачать производственный календарь
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;